import React from 'react';
import PropTypes from 'prop-types';

class ArrowIcon extends React.PureComponent {
	render() {
		const { width, height, fill } = this.props;

		const viewBox = [0, 0, width, height].join(' ');

		return (
			<svg width={width} height={height} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
				<title>Arrow Icon</title>
				<g fill={fill} transform="translate(-2.000000, -3.000000)">
					<path d="M15.7762265,8.43956688 L10.7203337,3.23031819 C10.5760097,3.08161989 10.3836536,3 10.1785496,3 C9.973218,3 9.78097571,3.08173716 9.63665171,3.23031819 L9.17761489,3.70338519 C9.03340471,3.85184896 8.95395822,4.05015245 8.95395822,4.26159018 C8.95395822,4.47291064 9.03340471,4.67789852 9.17761489,4.82636229 L12.1271512,7.8719803 L2.75633515,7.8719803 C2.33383461,7.8719803 2,8.21276679 2,8.64819013 L2,9.31698069 C2,9.75240403 2.33383461,10.1275506 2.75633515,10.1275506 L12.1606144,10.1275506 L9.17772871,13.1901728 C9.03351853,13.3388711 8.95407204,13.5317802 8.95407204,13.7432179 C8.95407204,13.9544211 9.03351853,14.1501446 9.17772871,14.2987257 L9.63676553,14.7702682 C9.78108953,14.9189665 9.97333182,15 10.1786634,15 C10.3837674,15 10.5761235,14.917911 10.7204475,14.7692127 L15.7763403,9.56008131 C15.9210058,9.41091392 16.0005661,9.21178954 15.999997,9.00011727 C16.0004522,8.78774138 15.9210058,8.58849973 15.7762265,8.43956688 Z" />
				</g>
			</svg>
		);
	}
}

ArrowIcon.defaultProps = {
	width: 14,
	height: 12,
	fill: '#F05B5E',
};

ArrowIcon.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	fill: PropTypes.string,
};

export default ArrowIcon;



// WEBPACK FOOTER //
// ./src/components/shared/icons/arrowIcon.js